/**
 * @file PhonePhotoRow.tsx
 * @description Строка «Другое фото для телефона» в шаге «Кадр под блок»
 * (phase19.16, партия SB120, этап 1; uiux-sb120-stage1 вопрос 8 — «кадр не
 * спасает фото с надписью внутри картинки»; данные db-design-sb120-stage1
 * §1 `mediaIdPhone`, нет ключа — то же фото). Своё фото есть — мини,
 * «Заменить» и «Убрать».
 */

import { ImagePlus } from "lucide-react";

import { Button } from "../../../ui/button";
import { contentMediaUrl } from "../../../../lib/api-content-media";

interface Props {
  /** Своё фото телефона; нет — то же фото, что на ПК. */
  mediaIdPhone?: string;
  onPick: () => void;
  onRemove: () => void;
}

export function PhonePhotoRow({ mediaIdPhone, onPick, onRemove }: Props) {
  if (!mediaIdPhone) {
    return (
      <div className="flex min-w-0 flex-col gap-1">
        <Button variant="outline" className="self-start" onClick={onPick}>
          <ImagePlus aria-hidden />
          Другое фото для телефона…
        </Button>
        <p className="type-caption text-on-surface-variant">Если на фото надпись или узкий кадр не помещается — поставьте отдельный файл для телефона.</p>
      </div>
    );
  }
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-2">
      <img src={contentMediaUrl(mediaIdPhone)} alt="" className="size-14 shrink-0 rounded-lg bg-surface-low object-cover" />
      <span className="type-body min-w-0 flex-1 text-on-surface">Своё фото для телефона</span>
      <Button variant="outline" onClick={onPick}>
        Заменить
      </Button>
      <Button variant="ghost" onClick={onRemove}>
        Убрать
      </Button>
    </div>
  );
}
